<template>
    <div class="row justify-content-md-center mt-3">
        <div class="col-md-24">
            <div class="card">
                <h5 class="card-header">
                    Trucks
                    <i v-if="loading && ! error" class="fa fa-spinner fa-spin float-right"></i>
                </h5>
                <div class="card-body table-responsive">
                    <div v-if="error" class="alert alert-warning mb-0">
                        {{ error }}
                    </div>
                    <div v-if="!loading && trucks.length == 0" class="alert alert-default">
                        You don't currently have any trucks.
                    </div>
                    <table v-if="trucks.length > 0" class="table">
                        <thead>
                            <th>Plate</th>
                            <th>Display Name</th>
                            <th>Make</th>
                            <th>Model</th>
                            <th>Engine Power (kw)</th>
                            <th>Number of Axles</th>
                            <th>Tare Weight (tonne)</th>
                            <th>GVM (tonne)</th>
                            <th>Last Activity</th>
                        </thead>
                        <tbody>
                            <tr v-for="(truck, index) in trucks" :key="truck.id">
                            <td>{{ truck.plate }}</td>
                            <td>{{ truck.display_name }}</td>
                            <td>{{ truck.make }}</td>
                            <td>{{ truck.model }} {{truck.sub_model}}</td>
                            <td>{{ truck.power }}</td>
                            <td>{{ truck.axel_count }}</td>
                            <td>{{ Math.trunc(truck.tare_weight / 1000) }}</td>
                            <td>{{ Math.trunc(truck.gross_vehicle_weight / 1000) }}</td>
                            <td>{{ truck.currentLocation ? moment(truck.currentLocation.data.time).fromNow() : 'No History'}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';

    export default {
        name: 'trucks-table',
        data() {
            return {
                loading: true,
                error: null,
                trucks: [],
            }
        },

        mounted() {
            this.loadTrucks();
        },

        methods: {
            moment,
            loadTrucks() {
                this.loading = true;
                this.trucks = [];
                api.get('/carrier/gps/trucks?type=minute&include=currentLocation')
                   .then((response) => {
                       this.trucks = response.data.data.sort(function(a, b){
                           if(a.plate < b.plate) { return -1; }
                           if(a.plate > b.plate) { return 1; }
                           return 0;
                       });
                       this.loading = false;
                   })
                   .catch((error) => {
                       this.error = "There was a problem loading your trucks, we've been notified and will look into it.";
                   });
            },
        },
    }
</script>
